module.exports = __webpack_public_path__ + "img/playstore.999f332b.png";